import React, {FC, useRef} from 'react'
import { ISpecialProductModel } from '../core/_models'

type IProps = {
  item: ISpecialProductModel
  onChange: any
  onEdit?: (id: number, field: 'quantity' | 'sale_price', value: string) => void
  edit?: {quantity: string | number; sale_price: string | number}
  isNewBarcode?: boolean
}
const ConnectedBarcodeTableRow: FC<IProps> = ({item, onChange, onEdit, edit, isNewBarcode}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(item.barcode, item.supplier_product_special_id, e.target.checked)
  }
  

  return (
    <tr className={`${isNewBarcode ? 'border-top border-dashed border-dark' : ''}`}>
      <td>
        <input
          ref={inputRef}
          onChange={handleChange}
          className='form-check-input'
          type='checkbox'
          value=''
          id='flexCheckDefault'
        />
      </td>
      <td>{item.barcode}</td>
      <th>
        <img width='100' height='100' src={item.image} />
      </th>
      <td>
        {item.name}
        {(item.size_label || item.color_label) ? (
          <div className='text-muted fs-8 fw-bold'>
            {[item.size_label, item.color_label].filter(Boolean).join(' · ')}
          </div>
        ) : null}
      </td>
      <td>{item.model}</td>
      <td>
        <input
          type='number'
          min={0}
          className='form-control form-control-sm'
          style={{width: '80px'}}
          value={edit?.quantity ?? item.data.quantity}
          onChange={(e) => onEdit && onEdit(item.supplier_product_special_id, 'quantity', e.target.value)}
        />
      </td>
      <td>
        <input
          type='number'
          step='0.01'
          min={0}
          className='form-control form-control-sm'
          style={{width: '90px'}}
          value={edit?.sale_price ?? item.data.sale_price.new_sale_price}
          onChange={(e) => onEdit && onEdit(item.supplier_product_special_id, 'sale_price', e.target.value)}
        />
      </td>
    </tr>
  )
}

export default ConnectedBarcodeTableRow
